module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vcirc8-b2c3d9aba49e3370af771691e23f0c8c.jpg";